// extracted by mini-css-extract-plugin
export var notchGap = "32px";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthTablet = "768px";